export default function isAndroid() {
  if (typeof navigator !== 'undefined' && navigator.userAgent) {
    return navigator.userAgent.toLowerCase().includes('android');
  }
  return false;
}
